/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from "react";
import createReactClass from "create-react-class";
import classnames from "classnames";
import Reflux from "reflux";

import Store from "okpay/stores/Store";
import Actions from "okpay/actions/Actions";
import C from "okpay/util/Constants";
import ClientStats from "shared/util/ClientStats";

// It's a little awkward for this to be listening to the store directly,
// but it ensures this always has the right data.

// also: there's thing:

// @state.selectedOption.paypalLink || @state.product.paypalLink

// it's just for backwards compatibility. sorry for the mess.
// if you're reading this in 2017 or beyond you can probably remove it.

import "./PurchaseButton.scss";

const PurchaseButton = createReactClass({
	displayName: "PurchaseButton",
	mixins: [Reflux.ListenerMixin],

	getInitialState() {
		return this._getState();
	},

	componentDidMount() {
		this.listenTo(Store, this._onStoreChange);
	},

	componentDidUpdate(prevProps, prevState) {
		// if we tried to open paypal, and it failed, try to open the link
		if (
			this.state.billingType === C.billingTypes.paypal &&
      !prevState.openPaypalAgain &&
      this.state.openPaypalAgain
		) {
			window.location.href =
        this.state.selectedOption.paypalLink || this.state.product.paypalLink;
		}
	},

	_onStoreChange(bundle) {
		const nextState = this._getState();
		this.setState(nextState);
	},

	_getState() {
		const storeState = Store.getAll();
		return storeState;
	},

	_onClick() {
		if (this.state.isSuccessful) {
			return;
		}

		// open paypal in the same window, if they have one
		if (this.state.usePaypalLink) {
			Actions.confirmPaypal();
			window.location.href =
        this.state.selectedOption.paypalLink || this.state.product.paypalLink;
		} else if (!this.state.isSubmitting) {
			Actions.confirmPurchase(this.state);
		}
	},

	render() {
		// if we're gonna try to reopen the paypal link,
		// return a little message to that effect.
		let buttonText;

		if (this.state.openPaypalAgain) {
			return <p className="okpay-purchasebutton-fallback">Opening PayPal…</p>;
		}

		const showSuccess = this.state.isSuccessful;
		const { isSubmitting } = this.state;
		const showSubmitting = isSubmitting && !this.props.alwaysBlue;

		if (showSuccess) {
			buttonText = "Success!";
		} else if (showSubmitting) {
			buttonText = "Submitting…";
		} else {
			buttonText = this.props.children;
		}

		const classes = classnames({
			big: true,
			flatbutton: true,
			"okpay-purchasebutton": true,
			green: showSuccess,
			blue: !showSubmitting && !showSuccess,
			disabled: showSubmitting && !showSuccess,
		});
		return (
			<div className="okpay-purchasebutton-container">
				{this.state.productId !== "update" && (
					<div className="okpay-purchasebutton-disclaimer">
            By clicking Confirm Purchase, you agree to the{" "}
						<a href="/legal/terms" target="_blank" rel="noopener noreferrer">
              Terms and Conditions
						</a>.
					</div>
				)}

				<div className="okpay-purchasebutton-buttoncontainer">
					<div className="okpay-purchasebutton-buttoncontainer-left">
						<button className={classes} onClick={this._onClick}>
							{buttonText}
						</button>
					</div>
					<div className="okpay-purchasebutton-buttoncontainer-right">
						{this.props.rightSide}
					</div>
				</div>

				{(this.state.productId !== "update" && this.state.isWAState) &&
					<div className="okpay-purchasebutton-washington">
						Washington residents are required to pay sales or use tax on
						certain purchases. Washington law requires Washington purchasers
						to review untaxed purchases and, if any tax is owed, file a
						Washington use tax return and pay any tax due. Visit{" "}
						<a
							href="https://dor.wa.gov/consumerusetax"
							target="_blank"
							rel="noopener noreferrer"
						>
							https://dor.wa.gov/consumerusetax
						</a>{" "}
						for more information. This notice is required by Engrossed House
						Bill 2163, section 205(2)(a).
					</div>
				}
			</div>
		);
	},
});

export default PurchaseButton;



// WEBPACK FOOTER //
// ./src/reflux/okpay/components/PurchaseButton.jsx